/** @jsxImportSource @emotion/react */

import { FC } from "react";
import { css } from "@emotion/react";
import CircularProgress from "../CircularProgress";

const CenterCircularProgress: FC = () => {
  const styles = css`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100vh;
    div {
      align-self: center;
    }
  `;
  return (
    <div css={styles}>
      <div>
        <CircularProgress size={"large"} />
      </div>
    </div>
  );
};

export default CenterCircularProgress;
